export default {
    configuration:{},
    measurement:[],
    products:{},
    product:{},
    price:0,
    qty:0,
    roll:'no',
    config_length_val:'',
    config1_input_one:{},

    config2_input_one:{},
    config2_input_two:{},
    config2_input_three:{},

    config3_input_one:{},
    config3_input_two:{},

    config4_input_one:{},
    config4_input_two:{},
    config4_input_three:{},

    config5_input_one:{},
    config5_input_two:{},

    config6_input_one:{},
    config6_input_two:{},

    config7_input_one:{},
    config7_input_two:{},
    config7_input_three:{},

    config8_input_one:{},
    config8_input_two:{},
}